import React from 'react'
import { useMakeSelector } from 'hooks/redux'
import {
  COMPONENT,
  LIST,
  RESET,
  SAVE,
  ERROR,
  REMOVE,
  ADD,
  NOT_FOUND,
  TIME_OUT_QR,
  NOT_FOUND_QR,
  LAYOUT_LOCATION_EDIT,
  SAVE_LAYOUT,
  DASH_VIEW,
} from 'utils/constants'
import { makeComponentMetaSelector } from 'selectors/navigator'
import {
  DetailsView,
  ListsView,
  ResetView,
  SaveView,
  ErrorView,
  RemoveView,
  AddView,
  NotFound,
  TimeOutQR,
  NotFoundQR,
  LayoutLocationEditor,
  SaveLayout,
} from '../DrawerViews'

const drawerViews = {
  [COMPONENT]: DetailsView,
  [LIST]: ListsView,
  [RESET]: ResetView,
  [SAVE]: SaveView,
  [ERROR]: ErrorView,
  [REMOVE]: RemoveView,
  [ADD]: AddView,
  [NOT_FOUND]: NotFound,
  [TIME_OUT_QR]: TimeOutQR,
  [NOT_FOUND_QR]: NotFoundQR,
  [LAYOUT_LOCATION_EDIT]: LayoutLocationEditor,
  [SAVE_LAYOUT]: SaveLayout,
}

const DashSidebarNavigator = () => {
  const { view } = useMakeSelector(makeComponentMetaSelector, {
    id: DASH_VIEW,
  })

  const Component = drawerViews[view || LIST]

  if (!Component) return null

  return <Component />
}

DashSidebarNavigator.propTypes = {}

export default DashSidebarNavigator
